/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_TitleInputs */

const cs_deal_splits_title = /** @type {(inputs: Deal_Splits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíly na provizi`)
};

const en_deal_splits_title = /** @type {(inputs: Deal_Splits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provision splits`)
};

/**
* | output |
* | --- |
* | "Provision splits" |
*
* @param {Deal_Splits_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_title = /** @type {((inputs?: Deal_Splits_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_title(inputs)
	return cs_deal_splits_title(inputs)
});